import { get } from 'lodash';
import logo from 'components/Article/logo.png';
import defaults from './defaults';
// assets

export default class {
  constructor({
    image,
    hero_image: heroImage,
    thumb_image: thumbImage,
    publication_date: publicationDate,
    content_summary: description,
    title,
    author = {},
    shareUrl,
  }) {
    this.image = image;
    this.heroImage = heroImage;
    this.thumbImage = thumbImage;
    this.description = description;
    this.title = title;
    this.author = author;
    this.shareUrl = shareUrl;
    this.publicationDate = publicationDate;
  }

  get bestImage() {
    return this.image || this.heroImage || this.thumbImage;
  }

  toJSON() {
    const data = {
      '@type': 'Article',
      '@id': 'article',
      datePublished: this.publicationDate,
      dateModified: this.publicationDate,
      description: this.description,
      headline: this.title,
      image: this.bestImage,
      author: {
        '@type': 'Person',
        name: get(this.author, 'name'),
      },
      publisher: [
        {
          '@type': 'Organization',
          name: 'Autolist',
          logo: {
            '@type': 'ImageObject',
            url: logo,
            height: 60,
            width: 300,
          },
        },
      ],
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': this.shareUrl,
      },
    };

    return { ...defaults, ...data };
  }
}
